import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class InvoiceService {
    logoUrl = `${window.location.origin}/assets/images/logoesign.png`;

    constructor() { }

    private formatDate(date: string | null | undefined): string {
        if (!date) {
            return '-';
        }

        const parsedDate = new Date(date);
        if (isNaN(parsedDate.getTime())) {
            return '-';
        }

        return parsedDate.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    }

    private numberToWords(amount: number): string {
        return `${amount.toLocaleString('en-IN')} Only`;
    }

    getInvoiceTemplate(customer: any, invoice: any) {
        // Check if device supports printing
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        const isTablet = /iPad|Android(?=.*\bMobile\b)|Tablet|PlayBook/i.test(navigator.userAgent);

        const items = invoice.invoiceDetails.items.map(
            (item: any, index: number) => {
                const unitPrice = Number(item.unitPrice || 0);
                const total = Number(item.total || 0);

                return `
        <tr>
          <td>${index + 1}</td>
          <td>${item.description ?? '-'}</td>
          <td>${item.quantity ?? 0}</td>
          <td>₹${unitPrice.toLocaleString('en-IN')}</td>
          <td>₹${total.toLocaleString('en-IN')}</td>
        </tr>
      `
            }).join('');

        const invoiceHTML = `
<html lang="en">

<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Invoice - ${invoice.invoiceNumber}</title>
    <style>
        @page {
            margin: 0;
            size: A4;
        }

        @media print {
            body {
                margin: 0;
                padding: 10px;
            }
            .no-print {
                display: none !important;
            }
        }

        body {
            margin: 0;
            padding: 20px;
            font-family: Arial, sans-serif;
            background: #f5f5f5;

            .receipt {
                width: 700px;
                max-width: 100%;
                height: auto;
                background: #fff;
                margin: 20px auto;
                padding: 30px;
                border: 1px solid #ccc;
                font-family: Arial, sans-serif;
                font-size: 14px;
                box-shadow: 0 0 10px rgba(0,0,0,0.1);

                .header {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 20px;

                    .logo {
                        width: 100px;
                        margin-right: 15px;

                        img {
                            width: 100%;
                            height: auto;
                            object-fit: contain;
                        }
                    }

                    .company-info {
                        text-align: left;
                        flex: 1;

                        h2 {
                            margin: 0 0 5px;
                            font-size: 22px;
                        }

                        p {
                            margin: 2px 0;
                            font-size: 14px;
                        }
                    }
                }

                .title {
                    text-align: center;
                    border: 2px solid #ccc;
                    padding: 4px 0;
                    margin: 0 0 10px;
                    font-weight: bold;
                    font-size: 18px;
                    background: #f8f9fa;
                }

                .content {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    flex-wrap: wrap;
                    gap: 10px;

                    .left,
                    .right {
                        width: 100%;
                        max-width: 48%;

                        p {
                            margin: 0;
                            font-size: 14px;
                            padding: 3px;
                            box-sizing: border-box;
                            border: 1px solid #dcdada;
                            border-collapse: collapse;
                            background: #f8f9fa;
                        }
                    }

                    .right {
                        display: inline;
                        justify-content: space-between;

                        .details {
                            width: 100%;
                        }
                    }
                }

                hr {
                    border: none;
                    border-top: 1px solid #ccc;
                }

                .invoice-detail {
                    display: flex;
                    justify-content: space-between;
                    gap: 20px;
                    margin: 16px 0;
                    flex-wrap: wrap;

                    .left-detail,
                    .right-detail {
                        width: 100%;
                        max-width: 48%;
                    }

                    p {
                        margin: 4px 0;
                        padding: 6px;
                        font-size: 14px;
                        background: #f8f9fa;
                        border: 1px solid #e9ecef;
                    }
                }


                .services {
                    width: 100%;
                    border-collapse: collapse;
                    margin: 0;
                    border: 1px solid #dee2e6;

                    th,
                    td {
                        padding: 8px 0;
                        font-size: 14px;
                        border: 1px solid #dee2e6;
                    }

                    th:first-child,
                    td:first-child {
                        text-align: left;
                        padding-left: 8px;
                    }

                    th:last-child,
                    td:last-child {
                        text-align: right;
                        padding-right: 8px;
                    }

                    th:nth-child(2),
                    td:nth-child(2),
                    th:nth-child(3),
                    td:nth-child(3),
                    th:nth-child(4),
                    td:nth-child(4) {
                        text-align: center;
                    }

                    th {
                        background: #f8f9fa;
                        font-weight: bold;
                    }
                }

                .summary {
                    margin-top: 10px;
                    width: 100%;
                    font-size: 14px;

                    .summary-row {
                        display: flex;
                        justify-content: space-between;
                        padding: 4px 0;

                        .label {
                            flex: 1;
                            text-align: right;
                            padding-right: 16px;
                            font-weight: bold;
                        }

                        .value {
                            text-align: center;
                            font-weight: bold;
                            padding-right: 0.5rem;
                        }

                        .amount {
                            color: green;
                            font-size: 16px;
                        }
                    }
                }

                .footer {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 20px;
                    padding-top: 10px;
                    border-top: 1px solid #dee2e6;

                    p {
                        margin: 2px 0;
                        font-size: 12px;
                        color: #6c757d;
                    }
                }

                .print-button {
                    text-align: center;
                    margin: 20px 0;
                }

                .print-btn {
                    background: #007bff;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 5px;
                    cursor: pointer;
                    font-size: 16px;
                }

                .print-btn:hover {
                    background: #0056b3;
                }
            }
        }
    </style>
</head>

<body>
    <div class="receipt">
        <div class="header">
            <div class="logo">
                <img src="${this.logoUrl}" alt="Company Logo" />
            </div>
            <div class="company-info">
                <h2>AVSS</h2>
                <p>59 Sec-63 Noida, UP</p>
                <p>Contact: +91-9876543xxx</p>
            </div>
        </div>

        <div class="title">Bill Receipt</div>

        <div class="content">
            <div class="left">
                <p><strong>Invoice Number:</strong> ${invoice.invoiceNumber}</p>
                <p><strong>Name:</strong> ${customer.name}</p>
                <p><strong>Email:</strong> ${customer.email}</p>
                </div>

                <div class="right">
                <div class="details">
                    <p><strong>Phone No:</strong> ${customer.phone}</p>
                    <p><strong>Company:</strong> ${customer.company}</p>
                    <p><strong>Created At:</strong> ${this.formatDate(customer.createdAt)}</p>
                </div>
            </div>
        </div>

        <div class="title">Invoice Detail</div>

        <div class="invoice-detail">

            <div class="left-detail">
                <p><strong>Plan Name:</strong> ${invoice.planName}</p>
                <p><strong>Status:</strong> ${invoice.status}</p>
                <p><strong>Subscription Activated:</strong> ${invoice.subscriptionActivated ? 'True' : 'False'}</p>
                <p><strong>Invoice Date:</strong>
                    ${this.formatDate(invoice.invoiceDetails.invoiceDate)}
                </p>
                                <p><strong>Plan Expired Date:</strong>
                    ${this.formatDate(invoice?.endDate)}
                </p>
            </div>

            <div class="right-detail">
                <p><strong>Transaction ID:</strong> ${invoice.transactionId}</p>
                <p><strong>Payment Method:</strong> ${invoice.paymentMethod}</p>
                <p><strong>Currency:</strong> ${invoice.currency}</p>
                <p><strong>Documents Limit:</strong> ${invoice?.documents || 0}</p>
                <p><strong>Users Limit:</strong> ${invoice?.users || 0}</p>
            </div>

        </div>

        <div class="note">
            <strong>Note:</strong> ${invoice.notes}
        </div>

        <hr />
        <div class="table-responsive">
        <table class="services">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Description</th>
                    <th>Qty</th>
                    <th>Unit Price</th>
                    <th>Total</th>
                </tr>
            </thead>
            <tbody>
                ${items}
            </tbody>
        </table>
        </div>
        <div class="summary">
            <div class="summary-row">
                <span class="label">Final Amount</span>
                <span class="value amount">₹${invoice.amount}</span>
            </div>
        </div>
        <hr />
        <div class="footer">
            <p>Thanks for Visit</p>
            <p>AVSS, 59 Sec-63, Noida,UP</p>
        </div>

        <div class="print-button no-print">
            <button class="print-btn" onclick="window.print()">Print Invoice</button>
        </div>
    </div>

</body>

</html>`

        // For mobile/tablet devices, open invoice in a new tab using a blob URL for better compatibility.
        if (isMobile || isTablet) {
            const blob = new Blob([invoiceHTML], { type: 'text/html' });
            const url = URL.createObjectURL(blob);
            const newWindow = window.open(url, '_blank');

            if (newWindow) {
                newWindow.focus();
            } else {
                const a = document.createElement('a');
                a.href = url;
                a.target = '_blank';
                a.rel = 'noopener noreferrer';
                a.download = `Invoice-${invoice.invoiceNumber}.html`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }

            setTimeout(() => URL.revokeObjectURL(url), 10000);
            return;
        }

        // Desktop printing logic (existing iframe approach)
        const oldIframe = document.getElementById('invoice-print-iframe');
        if (oldIframe) {
            oldIframe.remove();
        }

        const iframe = document.createElement('iframe');
        iframe.id = 'invoice-print-iframe';
        iframe.style.position = 'fixed';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = '0';
        iframe.style.visibility = 'hidden';

        document.body.appendChild(iframe);

        const iframeWindow = iframe.contentWindow;
        const iframeDoc = iframeWindow?.document;

        if (!iframeWindow || !iframeDoc) {
            console.error('Unable to access iframe');
            return;
        }

        // Write HTML
        iframeDoc.open();
        iframeDoc.write(invoiceHTML);
        iframeDoc.close();

        let hasPrinted = false;
        let isCleanedUp = false;
        let cleanupTimeout: ReturnType<typeof setTimeout>;

        const cleanup = () => {
            if (isCleanedUp) return;

            isCleanedUp = true;
            iframeWindow.removeEventListener('afterprint', cleanup);
            clearTimeout(cleanupTimeout);
            iframe.remove();
        };

        const printInvoice = () => {
            if (hasPrinted || isCleanedUp) return;

            hasPrinted = true;
            iframeWindow.addEventListener('afterprint', cleanup, { once: true });
            // Fallback for browsers that do not dispatch afterprint on an iframe.
            cleanupTimeout = setTimeout(cleanup, 60000);
            iframeWindow.focus();
            iframeWindow.print();
        };

        iframe.addEventListener('load', printInvoice, { once: true });
        if (iframeDoc.readyState === 'complete') {
            printInvoice();
        }

    }


    getStampOrderInvoice(customer: any, invoice: any) {
        console.log(customer)
        // Check if device supports printing
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        const isTablet = /iPad|Android(?=.*\bMobile\b)|Tablet|PlayBook/i.test(navigator.userAgent);

        const items = customer.items.map(
            (item: any, index: number) => {
                const total = Number((item.denomination * item.quantity) || 0);
                return `
        <tr>
          <td>${index + 1}</td>
          <td>${item.stateName ?? '-'}</td>
          <td>${item.denomination ?? 0}</td>
          <td>${item.quantity ?? 0}</td>
          <td>₹${total.toLocaleString('en-IN')}</td>
        </tr>
      `
            }).join('');

        const invoiceHTML = `
<html lang="en">

<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Invoice - ${invoice.invoiceId}</title>
    <style>
        @page {
            margin: 0;
            size: A4;
        }

        @media print {
            body {
                margin: 0;
                padding: 10px;
            }
            .no-print {
                display: none !important;
            }
        }

        body {
            margin: 0;
            padding: 20px;
            font-family: Arial, sans-serif;
            background: #f5f5f5;

            .receipt {
                width: 700px;
                max-width: 100%;
                height: auto;
                background: #fff;
                margin: 20px auto;
                padding: 30px;
                border: 1px solid #ccc;
                font-family: Arial, sans-serif;
                font-size: 14px;
                box-shadow: 0 0 10px rgba(0,0,0,0.1);

                .header {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 20px;

                    .logo {
                        width: 100px;
                        margin-right: 15px;

                        img {
                            width: 100%;
                            height: auto;
                            object-fit: contain;
                        }
                    }

                    .company-info {
                        text-align: left;
                        flex: 1;

                        h2 {
                            margin: 0 0 5px;
                            font-size: 22px;
                        }

                        p {
                            margin: 2px 0;
                            font-size: 14px;
                        }
                    }
                }

                .title {
                    text-align: center;
                    border: 2px solid #ccc;
                    padding: 4px 0;
                    margin: 0 0 10px;
                    font-weight: bold;
                    font-size: 18px;
                    background: #f8f9fa;
                }

                .content {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    flex-wrap: wrap;
                    gap: 10px;

                    .left,
                    .right {
                        width: 100%;
                        max-width: 48%;

                        p {
                            margin: 0;
                            font-size: 14px;
                            padding: 3px;
                            box-sizing: border-box;
                            border: 1px solid #dcdada;
                            border-collapse: collapse;
                            background: #f8f9fa;
                        }
                    }

                    .right {
                        display: inline;
                        justify-content: space-between;

                        .details {
                            width: 100%;
                        }
                    }
                }

                hr {
                    border: none;
                    border-top: 1px solid #ccc;
                }

                .invoice-detail {
                    display: flex;
                    justify-content: space-between;
                    gap: 20px;
                    margin: 16px 0;
                    flex-wrap: wrap;

                    .left-detail,
                    .right-detail {
                        width: 100%;
                        max-width: 48%;
                    }

                    p {
                        margin: 4px 0;
                        padding: 6px;
                        font-size: 14px;
                        background: #f8f9fa;
                        border: 1px solid #e9ecef;
                    }
                }


                .services {
                    width: 100%;
                    border-collapse: collapse;
                    margin: 0;
                    border: 1px solid #dee2e6;

                    th,
                    td {
                        padding: 8px 0;
                        font-size: 14px;
                        border: 1px solid #dee2e6;
                    }

                    th:first-child,
                    td:first-child {
                        text-align: left;
                        padding-left: 8px;
                    }

                    th:last-child,
                    td:last-child {
                        text-align: right;
                        padding-right: 8px;
                    }

                    th:nth-child(2),
                    td:nth-child(2),
                    th:nth-child(3),
                    td:nth-child(3),
                    th:nth-child(4),
                    td:nth-child(4) {
                        text-align: center;
                    }

                    th {
                        background: #f8f9fa;
                        font-weight: bold;
                    }
                }

                .summary {
                    margin-top: 10px;
                    width: 100%;
                    font-size: 14px;

                    .summary-row {
                        display: flex;
                        justify-content: space-between;
                        padding: 4px 0;

                        .label {
                            flex: 1;
                            text-align: right;
                            padding-right: 16px;
                            font-weight: bold;
                        }

                        .value {
                            text-align: center;
                            font-weight: bold;
                            padding-right: 0.5rem;
                        }

                        .amount {
                            color: green;
                            font-size: 16px;
                        }
                    }
                }

                .footer {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 20px;
                    padding-top: 10px;
                    border-top: 1px solid #dee2e6;

                    p {
                        margin: 2px 0;
                        font-size: 12px;
                        color: #6c757d;
                    }
                }

                .print-button {
                    text-align: center;
                    margin: 20px 0;
                }

                .print-btn {
                    background: #007bff;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 5px;
                    cursor: pointer;
                    font-size: 16px;
                }

                .print-btn:hover {
                    background: #0056b3;
                }
            }
        }
    </style>
</head>

<body>
    <div class="receipt">
        <div class="header">
            <div class="logo">
                <img src="${this.logoUrl}" alt="Company Logo" />
            </div>
            <div class="company-info">
                <h2>AVSS</h2>
                <p>59 Sec-63 Noida, UP</p>
                <p>Contact: +91-9876543xxx</p>
            </div>
        </div>

        <div class="title">Bill Receipt</div>

        <div class="content">
            <div class="left">
                <p><strong>Bulk Order Id:</strong> ${customer.bsrId}</p>
                <p><strong>Name:</strong> ${customer.clientName}</p>
                <p><strong>Email:</strong> ${customer.clientEmail}</p>
                </div>

                <div class="right">
                <div class="details">
                    <p><strong>Organisation:</strong> Axis Bank</p>
                    <p><strong>Created At:</strong> ${this.formatDate(customer.createdAt)}</p>
                </div>
            </div>
        </div>

        <div class="title">Invoice Detail</div>

        <div class="invoice-detail">

            <div class="left-detail">
                <p><strong>Invoice Id:</strong> ${invoice.invoiceId}</p>
                <p><strong>Status:</strong> ${invoice.status}</p>
                          
            </div>

            <div class="right-detail">
                <p><strong>Service Charge Rate:</strong> ${(invoice.serviceChargeRate) * 100}%</p>
                     <p><strong>Invoice Date:</strong>
                    ${this.formatDate(invoice.createdAt)}
                </p>
            </div>

        </div>

        <hr />
            <div class="table-responsive">
        <table class="services">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>State</th>
                    <th>Denomination</th>
                    <th>Qty</th>
                    <th>Price</th>
                </tr>
            </thead>
            <tbody>
                ${items}
            </tbody>
        </table>
    </div>
        <div class="summary">
            <div class="summary-row">
                <span class="label">Amount</span>
                <span class="value">₹${invoice.stampValue}</span>
            </div>
            <div class="summary-row">
                <span class="label">Service Charge</span>
                <span class="value">₹${invoice.serviceCharge}</span>
            </div>
            <div class="summary-row">
                <span class="label">Final Amount</span>
                <span class="value amount">₹${invoice.grandTotal}</span>
            </div>
        </div>
        <hr />
        <div class="footer">
            <p>Thanks for Visit</p>
            <p>AVSS, 59 Sec-63, Noida,UP</p>
        </div>

        <div class="print-button no-print">
            <button class="print-btn" onclick="window.print()">Print Invoice</button>
        </div>
    </div>

    <script>
        // Auto-print for desktop browsers, show print button for mobile
        if (!${isMobile || isTablet}) {
            window.onload = function() {
                setTimeout(function() {
                    window.print();
                }, 500);
            };
        }
    </script>
</body>

</html>`

        // For mobile/tablet devices, open invoice in a new tab using a blob URL for better compatibility.
        if (isMobile || isTablet) {
            const blob = new Blob([invoiceHTML], { type: 'text/html' });
            const url = URL.createObjectURL(blob);
            const newWindow = window.open(url, '_blank');

            if (newWindow) {
                newWindow.focus();
            } else {
                const a = document.createElement('a');
                a.href = url;
                a.target = '_blank';
                a.rel = 'noopener noreferrer';
                a.download = `Invoice-${invoice.invoiceNumber}.html`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }

            setTimeout(() => URL.revokeObjectURL(url), 10000);
            return;
        }

        // Desktop printing logic (existing iframe approach)
        const oldIframe = document.getElementById('invoice-print-iframe');
        if (oldIframe) {
            oldIframe.remove();
        }

        const iframe = document.createElement('iframe');
        iframe.id = 'invoice-print-iframe';
        iframe.style.position = 'fixed';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = '0';
        iframe.style.visibility = 'hidden';

        document.body.appendChild(iframe);

        const iframeWindow = iframe.contentWindow;
        const iframeDoc = iframeWindow?.document;

        if (!iframeWindow || !iframeDoc) {
            console.error('Unable to access iframe');
            return;
        }

        // Write HTML
        iframeDoc.open();
        iframeDoc.write(invoiceHTML);
        iframeDoc.close();

        const checkReady = setInterval(() => {
            if (iframeDoc.readyState === 'complete') {
                clearInterval(checkReady);

                setTimeout(() => {
                    iframeWindow.focus();
                    // iframeWindow.print();

                    // Cleanup after print
                    setTimeout(() => iframe.remove(), 1500);
                }, 300);
            }
        }, 50);

    }

}
